import Vue from 'vue'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI)
import eIconPicker from 'e-icon-picker';
import "e-icon-picker/lib/symbol.js"; //基本彩色图标库
import 'e-icon-picker/lib/index.css'; // 基本样式，包含基本图标
Vue.use(eIconPicker, {ElementUI: true, eIcon: true, eIconSymbol: true});

import '@/components'
import App from './App.vue'
import router from './router'
import store from './store'
import i18n from './i18n'
import $ from 'jquery'

import './plugins/admin-lte'

Vue.prototype.$ = $

Vue.config.productionTip = false

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')
